import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  placement: PropTypes.string
};

function Tip({ text, children, placement }) {
  const tooltip = <Tooltip id="tooltip"><div style={{fontWeight: '500'}}>{text}</div></Tooltip>;
  const placementValue = placement || 'top';
  return (
    <OverlayTrigger
      overlay={tooltip}
      placement={placementValue}
      delayShow={250}
      delayHide={400}
      trigger={['hover']}
    >
      {children}
    </OverlayTrigger>
  );
}

Tip.propTypes = propTypes;

export default Tip;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/Tip.js